import { useState, useEffect } from 'react';
import { homeMock } from '@/mocks/home';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-mahjong-cream/90 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2 group">
            <span
              className={`text-xl md:text-2xl font-serif font-bold transition-colors ${
                scrolled ? 'text-mahjong-dark' : 'text-white'
              }`}
            >
              雀荘 和
            </span>
            <span
              className={`text-xs font-sans transition-colors ${
                scrolled ? 'text-mahjong-warm' : 'text-white/70'
              }`}
            >
              なごみ
            </span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {homeMock.navbar.links.map((link) => (
              <button
                key={link.href}
                onClick={() => handleNavClick(link.href)}
                className={`text-sm font-sans font-medium whitespace-nowrap transition-colors hover:opacity-70 ${
                  scrolled ? 'text-mahjong-dark' : 'text-white'
                }`}
              >
                {link.label}
              </button>
            ))}
            <a
              href={homeMock.access.contacts.phone.href}
              className={`flex h-10 w-10 items-center justify-center rounded-full border text-sm transition-all hover:scale-105 ${
                scrolled
                  ? 'border-mahjong-dark/20 text-mahjong-dark hover:bg-mahjong-dark hover:text-white'
                  : 'border-white/40 text-white hover:bg-white hover:text-mahjong-dark'
              }`}
              aria-label="電話で問い合わせ"
            >
              <i className="ri-phone-line" />
            </a>
          </div>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="relative z-[70] flex h-10 w-10 items-center justify-center md:hidden"
            aria-label="メニュー"
            aria-expanded={mobileOpen}
          >
            <span
              className={`absolute h-px transition-all duration-300 ${
                mobileOpen
                  ? 'w-7 rotate-45 bg-white'
                  : `w-5 -translate-y-1.5 ${
                      scrolled ? 'bg-mahjong-dark' : 'bg-white'
                    }`
              }`}
            />
            <span
              className={`absolute h-px transition-all duration-300 ${
                mobileOpen
                  ? 'w-7 -rotate-45 bg-white'
                  : `w-7 translate-y-1.5 ${
                      scrolled ? 'bg-mahjong-dark' : 'bg-white'
                    }`
              }`}
            />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-[60] bg-mahjong-dark/95 backdrop-blur-xl transition-all duration-500 md:hidden ${
          mobileOpen
            ? 'pointer-events-auto opacity-100'
            : 'pointer-events-none opacity-0'
        }`}
      >
        <div className="absolute inset-y-16 right-8 flex items-center font-serif text-[12rem] leading-none text-white/5">
          和
        </div>
        <div className="flex min-h-screen flex-col items-center justify-center gap-8 px-6">
          {homeMock.navbar.links.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className={`font-serif text-3xl text-white transition-all duration-500 ${
                mobileOpen ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
              }`}
              style={{
                transitionDelay: mobileOpen
                  ? `${homeMock.navbar.links.indexOf(link) * 100 + 120}ms`
                  : '0ms',
              }}
            >
              {link.label}
            </button>
          ))}
          <a
            href={homeMock.access.contacts.phone.href}
            onClick={() => setMobileOpen(false)}
            className={`mt-8 inline-flex items-center gap-3 rounded-full border border-white/30 px-7 py-3 text-sm text-white transition-all duration-500 hover:bg-white hover:text-mahjong-dark ${
              mobileOpen ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
            }`}
            style={{
              transitionDelay: mobileOpen
                ? `${homeMock.navbar.links.length * 100 + 160}ms`
                : '0ms',
            }}
          >
            <i className="ri-phone-line" />
            電話する
          </a>
          <button
            onClick={() => handleNavClick('#access')}
            className={`text-xs tracking-[0.4em] text-white/50 transition-all duration-500 ${
              mobileOpen ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
            }`}
            style={{
              transitionDelay: mobileOpen
                ? `${homeMock.navbar.links.length * 100 + 240}ms`
                : '0ms',
            }}
          >
            ACCESS
          </button>
        </div>
      </div>
    </nav>
  );
}